import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { rem, spacing } from './../../../styles';
import StyledFormFieldInput from './form-field.input.styles';
var defaultStyles = /*#__PURE__*/css("border-radius:", rem(2), ";height:auto;margin:", rem(1), ";max-height:none;min-height:", rem(spacing.spacingControlHeightTextarea), ";padding:", rem(8), ";resize:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1qmr6ab",
  styles: "overflow:auto"
} : {
  name: "3h2ibu-autoExpandStyles",
  styles: "overflow:auto;label:autoExpandStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "40w5or-autoExpandStyles",
  styles: "overflow:hidden;label:autoExpandStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var autoExpandStyles = function autoExpandStyles(_ref3) {
  var autoExpand = _ref3.autoExpand;
  if (autoExpand) {
    return _ref2;
  }
  return _ref;
};
var StyledFormFieldTextArea = /*#__PURE__*/_styled(StyledFormFieldInput, process.env.NODE_ENV === "production" ? {
  target: "e4yl0460"
} : {
  target: "e4yl0460",
  label: "StyledFormFieldTextArea"
})(defaultStyles, autoExpandStyles).withComponent('textarea', process.env.NODE_ENV === "production" ? {
  target: "e4yl0461"
} : {
  target: "e4yl0461",
  label: "StyledFormFieldTextArea"
});
export default StyledFormFieldTextArea;